import GratificationsView from '../GratificationsView.vue'
import GratificationList   from '../Pages/GratificationList.vue'
import GratificationWizard from '../Pages/GratificationWizard.vue'
import GratificationDetail from '../Pages/GratificationDetail.vue'

const routes = [
  {
    path: '/gratificaciones',
    component: GratificationsView,
    children: [
      { path: '',         name: 'gratification-list',     component: GratificationList   },
      { path: 'calcular', name: 'gratification-calculate', component: GratificationWizard },
      { path: ':id',      name: 'gratification-detail',    component: GratificationDetail },
    ],
  },
]

export default routes
